<app-lead-account-modal (selectedAccounts)='this.onSelectedAccounts($event)'></app-lead-account-modal>
<!-- <app-new-contact-modal (selectedContact)='this.onSelectedContacts($event)'></app-new-contact-modal> -->
<app-contact-modal (selectedContacts)='this.onSelectedContacts($event)'></app-contact-modal>

<app-tabs>
  <app-tab title='Main Details'>
    <div class="form-row">
      <div class="form-group col-4">
        <label>Subject</label>
        <input
          type='text'
          [(ngModel)]='this.lead.subject'
          [class.is-invalid]='this.lead.subject === ""'
          [class.is-valid]='this.lead.subject.length > 1 && this.lead.subject !== " "'
          class='form-control'
          />
      </div>
      <div class="form-group col-4">
        <label>Estimated Revenue</label>
        <input
          type='number'
          [(ngModel)]='this.lead.estimatedRevenue'
          [class.is-invalid]='this.lead.estimatedRevenue < 0'
          [class.is-valid]='this.lead.estimatedRevenue > -1'
          class='form-control'
          />
      </div>
      <div class="form-group col-4">
        <label>Owner</label>

        <select
          class="form-control"
          (change)='changeOwner($event)'
          [class.is-invalid]='this.lead.ownerId === -1'
          [class.is-valid]='this.lead.ownerId > 0'
          >
          <option value="-1" [selected]='this.lead.ownerId === -1'>Select an Owner...</option>
          @for (user of this.users; track user) {
            <option
              [value]="user.id"
              [selected]='user.id === this.lead.ownerId'
            >{{user.firstName}} {{user.lastName}}</option>
          }
        </select>
      </div>
      <div class="form-group col-4">
        <label>Lead Source</label>
        <input
          type='text'
          [(ngModel)]='this.lead.leadSource'
          class='form-control'
          />
      </div>
      <div class="form-group col-4">
        <label>Phone Number</label>
        <input
          type='text'
          [(ngModel)]='this.lead.phone'
          class='form-control'
          />
      </div>
      <div class="form-group col-4">
        <label>Email</label>
        <input
          type='text'
          [(ngModel)]='this.lead.email'
          class='form-control'
          />
      </div>

      @if (this.lead.accountId === -1) {
        <div class="form-group col-4">
          <button class='btn btn-info' type='button' (click)='this.openModal("leadAccountModal")'>Add/Create Account</button>
        </div>
      }
      @if (this.lead.accountId !== -1 && this.lead.accountId !== null) {
        <div class="form-group col-4">
          <label>Account</label>
          <input class='form-control' readonly [(ngModel)]='this.lead.account.name'/>
          <button class='btn btn-info' type='button' (click)='this.openModal("leadAccountModal")'>Change Account</button>
          <button class='btn btn-danger' type='button' (click)='this.deleteAccount()'>Remove Account</button>
        </div>
      }

      <!-- <ng-container *ngIf='this.lead.contactId === -1 || this.lead.contactId === null'>
      <div class="form-group col-4">
        <button class='btn btn-info' type='button' (click)='this.openModal("contactModal")'>Find/Create Contact</button>
        <h6 *ngIf='this.lead.contactId !== -1 && this.lead.contactId !== null'>{{this.lead.contact.firstName}} {{this.lead.contact.lastName}}</h6>
      </div>
    </ng-container>
    <ng-container *ngIf='this.lead.contactId !== -1 && this.lead.contactId !== null'>
      <div class="form-group col-4">
        <label>Contact</label>
        <input class='form-control' readonly [(ngModel)]='this.contactName'/>
        <button class='btn btn-info' type='button' (click)='this.openModal("contactModal")'>Change Contact</button>
      </div>
    </ng-container> -->


    <div class="form-group col-4">
      <label>Lead Type</label>
      <select
        class="form-control"
        (change)='changeType($event)'
        [class.is-invalid]='this.lead.typeId === -1'
        [class.is-valid]='this.lead.typeId > 0'
        >
        <option value="-1" [selected]='this.lead.typeId === -1'>Select a Lead Type...</option>
        @for (type of this.types; track type) {
          <option
            [value]="type.id"
            [selected]='type.id === this.lead.typeId'
          >{{type.name}}</option>
        }
      </select>
    </div>
    <div class="form-group col-4">
      <label>Lead Status</label>
      <select
        class="form-control"
        (change)='changeStatus($event)'
        [class.is-invalid]='this.lead.statusId === -1'
        [class.is-valid]='this.lead.statusId > 0'
        >
        <option value="-1" [selected]='this.lead.statusId === -1'>Select a Lead Status...</option>
        @for (status of this.statuses; track status) {
          <option
            [value]="status.id"
            [selected]='status.id === this.lead.statusId'
          >{{status.name}}</option>
        }
      </select>
    </div>
    <div class="form-group col">
      <label>Notes</label>
      <textarea [(ngModel)]='this.lead.leadNotes' class='form-control'></textarea>
    </div>
  </div>

  @if (this.incumbents.length !== 0) {
    <div class="row">
      <div class="col content-block p-3">
        <h3>Incumbents</h3>
        <hr>
          <ul>
            @for (incumbent of this.incumbents; track incumbent) {
              <li>{{incumbent.incumbent.name}}</li>
            }
          </ul>
        </div>
      </div>
    }
  </app-tab>
  @if (this.lead.id !== -1) {
    <app-tab title='Discussion'>
      <app-discussion [data]='this.lead' entity='lead'></app-discussion>
    </app-tab>
  }
</app-tabs>
